// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3bn9e","content":"LoadingAlert_content__3L-aC"};